import { Button, Modal, ModalBody, ModalDialog, ModalHeader, ModalTitle } from '@ax/ui';
import {
  navigationSlice,
  selectUnsavedChangesModal,
  useAppDispatch,
  useAppSelector,
} from '@ax/redux-store';

export interface ConfirmationModal {
  modalOpen?: boolean;
  modalConfirm?: () => void;
  modalClose?: () => void;
  content?: { title: string; confirmButton?: string; cancelButton?: string; text: string };
}

const ConfirmationModal = ({
  modalOpen = false,
  modalConfirm,
  modalClose,
  content,
}: ConfirmationModal) => {
  const dispatch = useAppDispatch();
  const useUnsavedChangesModal = useAppSelector(selectUnsavedChangesModal);

  const handleModalConfirm = () => {
    if (modalConfirm) {
      modalConfirm();
    }
    dispatch(navigationSlice.actions.unsavedChangesModalConfirmed());
  };

  const handleModalClose = () => {
    if (modalClose) {
      modalClose();
    }
    dispatch(navigationSlice.actions.unsavedChangesModalClosed());
  };

  return (
    <Modal onShow={modalOpen}>
      <ModalDialog>
        <ModalHeader onHide={handleModalClose}>
          <ModalTitle>{useUnsavedChangesModal.title}</ModalTitle>
        </ModalHeader>
        <ModalBody>
          {useUnsavedChangesModal.message}
          <br />
          <div className="flex flex-col items-center justify-center">
            <Button
              className="h-[40px] mt-[10px]"
              variant="primary"
              block
              type="submit"
              onClick={handleModalConfirm}
            >
              {content?.confirmButton || 'Continue'}
            </Button>
            <Button
              className="h-[40px] mt-[10px]"
              variant="plain"
              block
              type="submit"
              onClick={handleModalClose}
            >
              {content?.cancelButton || 'Cancel'}
            </Button>
          </div>
        </ModalBody>
      </ModalDialog>
    </Modal>
  );
};

export default ConfirmationModal;
